import { presentScanControlRelation, type ScanControlRelationView } from '../../../domain/safetyCases/scanControlTemporalRelation';
import type { ScanMeasurementSource } from '../../../domain/cameraMeasurement/scanMeasurementIdentity';
import { resolveCanonicalLayerBMeasurementSource } from '../../../domain/safetyScanReport/canonicalStoredMeasurementBasis';

type PersistedScanReport = {
  site_id?: string | null;
  device_id?: string | null;
  camera_id?: string | null;
  window_start_utc?: string | null;
  window_end_utc?: string | null;
  workflow_id?: string | null;
  effective_measurement_basis?: Record<string, unknown> | null;
  workflow_anchor?: {
    workflow_id?: string | null;
    scope?: {
      site_id?: string | null;
      device_id?: string | null;
      camera_id?: string | null;
      zone_id?: string | null;
      zone_version?: number | null;
      risk_type?: string | null;
      zones?: unknown;
    } | null;
    time_window?: { start?: string | null; end?: string | null; from?: string | null; to?: string | null } | null;
  } | null;
};

type ControlActionLike = {
  control_revision_id?: string | null;
  id?: string | null;
  implemented_at?: string | null;
} | null;

export function resolveSafetyScanMeasurementContext(args: {
  persisted?: PersistedScanReport | null;
  siteIdFromSearch?: string | null;
  signed?: boolean;
  controlAction?: ControlActionLike;
}): { source: ScanMeasurementSource; controlRelation: ScanControlRelationView } {
  const persisted = args.persisted || {};
  const scope = persisted.workflow_anchor?.scope || {};
  const timeWindow = persisted.workflow_anchor?.time_window || {};
  const source: ScanMeasurementSource = resolveCanonicalLayerBMeasurementSource({
    persisted: persisted as Record<string, unknown>,
    riskType: scope.risk_type,
    workflowId: persisted.workflow_id || persisted.workflow_anchor?.workflow_id,
    windowStart: persisted.window_start_utc || timeWindow.start || timeWindow.from,
    windowEnd: persisted.window_end_utc || timeWindow.end || timeWindow.to,
    siteFallback: scope.site_id || args.siteIdFromSearch,
    deviceFallback: scope.device_id || persisted.device_id,
    cameraFallback: scope.camera_id || persisted.camera_id,
    signed: Boolean(args.signed),
  });
  return {
    source,
    controlRelation: presentScanControlRelation({
      windowStart: source.windowStart,
      windowEnd: source.windowEnd,
      controlRevisionId: String(args.controlAction?.control_revision_id || args.controlAction?.id || '').trim() || null,
      implementedAt: String(args.controlAction?.implemented_at || '').trim() || null,
    }),
  };
}
